'use client';

import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProfileHeading } from '@eliadmin/core/src/components/profile/profile-heading';
import { SubscriptionCard } from '@eliadmin/core/src/components/subscription/subscription-card';
import { ProfileContainer } from '@eliadmin/core/src/components/profile/profile-container';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export default function Page() {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);

  return (
    <>
      <ProfileContainer>
        <ProfileHeading title={t('text1917')} />
        <div className="flex w-full flex-col items-center justify-center gap-4 sm:gap-5 lg:gap-6">
          {me?.customer?.active_subscriptions.length === 0 ? (
            <p className="text-center text-sm text-black/70 sm:text-base">
              {t('text2419')}&nbsp;
              <Link
                prefetch={false}
                href={ROUTES.SUBSCRIPTION()}
                className="font-semibold text-primary underline"
              >
                {t('text2420')}
              </Link>
            </p>
          ) : (
            <>
              <h5
                className={cn(
                  'w-full text-center text-2xl font-medium sm:text-3xl',
                  'font-heading tracking-tight',
                )}
              >
                {t('text1927')}
              </h5>
              {/* <p
                className={cn(
                  'w-full text-center text-sm font-normal text-black/70 sm:text-base',
                  'font-heading tracking-tight',
                )}
              >
                {t('text1928')}
              </p> */}
            </>
          )}
        </div>
        <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-2">
          {me?.customer?.active_subscriptions.map(subscription => (
            <SubscriptionCard subscription={subscription} key={subscription.id} />
          ))}
        </div>
      </ProfileContainer>
    </>
  );
}
